(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ngLazyShow', ngLazyShow);

    ngLazyShow.$inject = ['$animate'];

    function ngLazyShow($animate) {
        // source: https://gist.github.com/accolver/4987806b026fd8a03568
        return {
            multiElement: true,
            transclude: 'element',
            priority: 600,
            terminal: true,
            restrict: 'A',
            link: function($scope, $element, $attr, $ctrl, $transclude) {
                var loaded;
                $scope.$watch($attr.ngLazyShow, function(value) {
                    if (loaded) {
                        $animate[value ? 'removeClass' : 'addClass']($element, 'ng-hide');
                    }
                    else if (value) {
                        loaded = true;
                        $transclude(function(clone) {
                            clone[clone.length++] = document.createComment(' end ngLazyShow: ' + $attr.ngLazyShow + ' ');
                            $animate.enter(clone, $element.parent(), $element);
                            $element = clone;
                        });
                    }
                });
            }
        };
    }
})();